/** @jsxImportSource @emotion/react */
import {useMemo} from 'react'
import {toast} from 'react-toastify'

import DashboardContent from 'components/dme/atoms/DashboardContent'
import Button from 'components/atoms/Button'
import {Form, Formik} from 'formik'
import {NotificationPreferences} from 'components/organisms/user/NotificationPreferences'
import {notificationTypes} from 'components/organisms/user/notificationsData'
import {
  useGetPhysicianGroupProfileQuery,
  useUpdatePhysicianGroupProfileMutation,
} from 'store/services/physicianGroupProfile'

const notificationKeys = [
  notificationTypes.HST_ORDER_CREATED,
  notificationTypes.ORDER_CANCELLED,
  notificationTypes.NEW_REPORT_READY_COX,
  notificationTypes.NEW_REPORT_READY_HST,
  notificationTypes.NEW_REPORT_READY_POX,
]

type FormValues = Record<string, boolean>

const NotificationSettings = () => {
  const { data } = useGetPhysicianGroupProfileQuery()
  const [updateProfile] = useUpdatePhysicianGroupProfileMutation()

  const initialValues = useMemo(() => {
    const notificationPreferences = data?.notificationPreferences || {}

    return notificationKeys.reduce<FormValues>((acc, key) => {
      acc[key] = notificationPreferences[key]?.email || false
      return acc
    }, {} as FormValues)
  }, [data])

  return (
    <DashboardContent
      title="Email Notifications"
      content={
        <div className="card card-primary mt-3">
          <Formik
            enableReinitialize
            initialValues={initialValues}
            onSubmit={async (values: FormValues) => {
              const nextPreferences = {
                ...(data?.notificationPreferences || {}),
              }

              notificationKeys.forEach((key) => {
                nextPreferences[key] = {
                  email: values[key],
                  sms: nextPreferences[key]?.sms || false,
                }
              })

              await updateProfile({ notificationPreferences: nextPreferences }).unwrap()
              toast.success('Notification settings updated.')
            }}>
            <Form className="card-body">
              <NotificationPreferences view="physicianGroup" />
              <div className="mt-3">
                <Button className="btn btn-primary" type="submit" label="Save Settings" />
              </div>
            </Form>
          </Formik>
        </div>
      }
      breadcrumb={[{ label: 'Home', to: '/physicians' }, { label: 'Email Notifications' }]}
    />
  )
}

export default NotificationSettings
